import React from "react";
import BaseButton from "@components/library/UI/BaseButton";
import ArrowIcon from "@components/library/Icons/ArrowIcon";
import "./FeatureCardButton.sass";

const FeatureCardButton = ({
  children,
  variant = "light",
  disabled = false,
  showArrow = true,
  className = "",
  type = "button",
  onClick,
  ...props
}) => {
  const variantClass = disabled
    ? "feature-card-button--disabled"
    : `feature-card-button--${variant}`;

  const classes = `feature-card-button ${variantClass} ${className}`.trim();

  return (
    <BaseButton
      className={classes}
      disabled={disabled}
      type={type}
      onClick={onClick}
      {...props}
    >
      <span className="whitespace-nowrap">{children}</span>
      {showArrow && <ArrowIcon className="feature-card-button__icon" />}
    </BaseButton>
  );
};

export default FeatureCardButton;